import { Component, EventEmitter, Input, NgZone, OnChanges, Output , ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import { SearchCarrierEquipment } from '../../models/models';

@Component({
    selector: 'carrier-equipment-grid',
    templateUrl: './carrier-equipment-grid.component.html',
    standalone: false
})
export class CarrierEquipmentGrid implements OnChanges {
    @Input() carrierID: number = 0;

    @Output() CarrierEquipmentSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild(GridComponent, { static: false }) public carrierEquipmentGrid!: GridComponent;

    public isLoading: boolean = false;
    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public carrierEquipmentID: number = 0;
    public carrierEquipmentList: SearchCarrierEquipment[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'trailerTypeAbbrev' }] };

    constructor(private cseService: CSEService, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getEquipment();
    }

    private getEquipment() {
        this.isLoading = true;
        this.cseService.getSearchCarrierEquipmentByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.carrierEquipmentList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.carrierEquipmentList = orderBy(this.carrierEquipmentList, this.gridState.sort);

        this.gridData = process(this.carrierEquipmentList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carrierEquipmentGrid == null) return;
            this.carrierEquipmentGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(carrierEquipmentID: number) {
        this.carrierEquipmentID = carrierEquipmentID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public addNew() {
        this.carrierEquipmentID = 0;
        this.isEdit = false;
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
    }

    public refreshGrid() {
        this.cancelEdit();
        this.getEquipment();
    }
}